import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getImageSize } from '@core/helpers/getSlideSize';
import { MediaInfo } from '@core/models/media-info.model';

@Component({
  selector: 'app-gallery-image',
  templateUrl: './gallery-image.component.html',
  styleUrls: ['./gallery-image.component.scss']
})
export class GalleryImageComponent implements OnInit {
  @Input() image: MediaInfo;
  @Input() index: number;
  @Output() handleSlideEvent = new EventEmitter<object>();

  constructor() { }

  ngOnInit(): void {
    if (this.image) {
      const img: HTMLImageElement = new Image();
      img.src = this.image.url;

      img.onload = () => {
        setTimeout(() => {
          this.handleSlideEvent.emit({ width: getImageSize({width: img.width, height: img.height}).width, index: this.index });
        }, 100);
      };
    }
  }


}
